// extracted by mini-css-extract-plugin
export var md = "_5j-4";
export var semantic = "_5j-5";
export var sm = "_5j-3";
export var text = "_5j-6";
export var toggleInput = "_5j-0";
export var toggleSwitch = "_5j-1";
export var xs = "_5j-2";